import type { CreateOfferCargoFormSchemaType } from "@/pages/admin-cargo-create/model/validation";
import { BaseAccordion } from "@/shared/ui/base-accordion";
import { BaseAccordionSummary } from "@/shared/ui/base-accordion-summary";
import { BaseDateTimePicker } from "@/shared/ui/base-datetime-picker";
import { BaseFormLabel } from "@/shared/ui/base-form-label";
import { AccordionDetails, Box } from "@mui/material";
import {} from "@mui/x-date-pickers";
import { type Control, Controller } from "react-hook-form";

export const DeliveryProposalForm = ({
  control,
}: {
  control: Control<CreateOfferCargoFormSchemaType>;
}) => {
  return (
    <BaseAccordion>
      <BaseAccordionSummary>配送提案受付</BaseAccordionSummary>
      <AccordionDetails>
        <BaseFormLabel label="受付期限" isRequired>
          <Box display="flex" gap={1}>
            <Controller
              name="deadlineAt"
              control={control}
              render={({ field, fieldState }) => {
                return (
                  <BaseDateTimePicker
                    {...field}
                    error={fieldState.invalid}
                    helperText={fieldState.error?.message}
                  />
                );
              }}
            />
          </Box>
        </BaseFormLabel>
      </AccordionDetails>
    </BaseAccordion>
  );
};
